import { render, staticRenderFns } from "./ServiceOrdersClosedByMonth.vue?vue&type=template&id=90661710"
import script from "./ServiceOrdersClosedByMonth.vue?vue&type=script&lang=js"
export * from "./ServiceOrdersClosedByMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports